module.exports = __webpack_public_path__ + "img/ico_social_linkedin--white.f71c52d8.svg";